// removed by extract-text-webpack-plugin
module.exports = {"dummy":"DummyBanner-module__dummy___P1s9C","mobile":"DummyBanner-module__mobile___3iWuB","fixed-banner":"DummyBanner-module__fixed-banner___1zyaK"};


//////////////////
// WEBPACK FOOTER
// ./src/js/components/DummyBanner/DummyBanner.module.scss
// module id = 286
// module chunks = 0 1